import {
  SET_USER,
  SET_ERRORS,
  //CLEAR_ERRORS,
  //LOADING_UI,
  SET_UNAUTHENTICATED,
  //LOADING_POSTS,
  //LOADING_POSTDIALOG,
  LOADING_PROFILE,
  //LOADING_NEWPOST,
  LOADING_CREDENTIALS,
  //STOP_LOADING,
  MARK_NOTIFICATIONS_READ,
  FOLLOW_USER,
  UNFOLLOW_USER,
  STOP_LOADING_CREDENTIALS,
  STOP_LOADING_PROFILE,
} from "../types";

import axios from "axios";

// set the login from the action
export const loginUser = (userData, history) => (dispatch) => {
  // dispatch sends the actual action
  dispatch({ type: LOADING_CREDENTIALS });
  axios
    .post("/login", userData)
    .then((res) => {
      setAuthorizationHeader(res.data.token);
      dispatch(getUserData());
      dispatch({ type: STOP_LOADING_CREDENTIALS });
      //dispatch({ type: CLEAR_ERRORS });      
      history.push("/home");
    })
    .catch((err) => {
      console.log(err)
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const forgotPassword = (userData, history) => (dispatch) => {
  // dispatch to login page after sending the reset email
  dispatch({ type: LOADING_CREDENTIALS });
  axios
    .post("/forgotPassword", userData)
    .then((res) => {
      dispatch({ type: STOP_LOADING_CREDENTIALS });
      //dispatch({ type: CLEAR_ERRORS });
      history.push("/login");
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const signupUser = (newUserData, history) => (dispatch) => {
  dispatch({ type: LOADING_CREDENTIALS });
  axios
    .post("/signup", newUserData)
    .then((res) => {
      setAuthorizationHeader(res.data.token);
      dispatch({ type: STOP_LOADING_CREDENTIALS });
      dispatch(getUserData());
      //dispatch({ type: CLEAR_ERRORS });
      history.push("/home");
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data,
      });
    });
};

// log out user and delete the authToken
export const logoutUser = () => (dispatch) => {
  localStorage.removeItem("FBIdToken");
  delete axios.defaults.headers.common["Authorization"];
  dispatch({ type: SET_UNAUTHENTICATED });
};

// gets information from the user and sends it to redux
export const getUserData = () => (dispatch) => {
  dispatch({ type: LOADING_PROFILE });
  axios
    .get("/user")
    .then((res) => {
      console.log(res.data)
      dispatch({
        type: SET_USER,
        payload: res.data,
      });
      dispatch({ type: STOP_LOADING_PROFILE });
    })
    .catch((err) => {
      console.log(err)
      // dispatch({
      //   type: SET_ERRORS,
      //   payload: err.response.data,
      // });
    });
};

export const uploadImage = (formData) => (dispatch) => {
  dispatch({ type: LOADING_PROFILE });
  axios
    .post("/user/image", formData)
    .then(() => {
      dispatch(getUserData());
      dispatch({ type: STOP_LOADING_PROFILE });
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const editUserDetails = (userDetails) => (dispatch) => {
  dispatch({ type: LOADING_PROFILE });

  console.log(userDetails);

  axios
    .post("/user", userDetails)
    .then(() => {
      console.log("Updated user details");
      dispatch(getUserData());
      dispatch({ type: STOP_LOADING_PROFILE });
    })
    .catch((err) => {
      console.log(err)
      // dispatch({
      //   type: SET_ERRORS,
      //   payload: err.response.data,
      // });
    });
};

export const markNotificationsRead = (notificationIds) => (dispatch) => {
  //dispatch({type: LOADING_HOME})
  axios
    .post("/notifications", notificationIds)
    .then((res) => {
      dispatch({
        type: MARK_NOTIFICATIONS_READ,
      });
      //dispatch({ type: STOP_LOADING });
    })
    .catch((err) => {
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const followUser = (followData) => (dispatch) => {
  // dispatch({type: LOADING_UI})
  axios
        .post("/follow", followData)
        .then((res) => {
          dispatch({
            type: FOLLOW_USER,
            payload: {followHandle: followData},
          });
          //dispatch({ type: STOP_LOADING_UI });
          console.log(res.data);
        })
        .catch((err) => {
          dispatch({
            type: SET_ERRORS,
            payload: err.response.data,
          });
        });
}

export const unfollowUser = (unfollowData) => (dispatch) => {
  // dispatch({type: LOADING_UI})
  console.log(unfollowData)
  axios
        .post("/unfollow", unfollowData)
        .then((res) => {
          dispatch({
            type: UNFOLLOW_USER,
            payload: {unfollowHandle: unfollowData.user},
          });
          //dispatch({ type: STOP_LOADING_UI });
          console.log(res.data);
        })
        .catch((err) => {
         console.log(err)
          // dispatch({
          //   type: SET_ERRORS,
          //   payload: err.response.data,
          // });
        });
}

// set the header of the axios request with the Bearer token required
const setAuthorizationHeader = (token) => {
  const FBIdToken = `Bearer ${token}`;
  localStorage.setItem("FBIdToken", FBIdToken);
  axios.defaults.headers.common["Authorization"] = FBIdToken;
};
